var map = {
	"./go/go.js": [
		"4481",
		"chunk-2d0c0e6f"
	],
	"./javascript/XMLHttpRequest.js": [
		"4e4b",
		"chunk-2d0cc615"
	],
	"./javascript/axios.js": [
		"7b4a",
		"chunk-2d0e17ee"
	],
	"./javascript/fetch.js": [
		"668b",
		"chunk-2d0cfee0"
	],
	"./javascript/jq.js": [
		"449b",
		"chunk-2d0c0ebf"
	],
	"./node/fetch.js": [
		"f697",
		"chunk-2d22d0a4"
	],
	"./node/fetch_node.js": [
		"99fd",
		"chunk-2d0e6cd4"
	],
	"./node/native.js": [
		"86ec",
		"chunk-2d0ded12"
	],
	"./node/native_node.js": [
		"f2a3",
		"chunk-2d22c674"
	],
	"./node/nodeAxios.js": [
		"abd0",
		"chunk-2d213523"
	],
	"./node/request.js": [
		"bce1",
		"chunk-2d21ad63"
	],
	"./node/request_node.js": [
		"a05e",
		"chunk-2d2073f5"
	],
	"./node/unirest.js": [
		"5903",
		"chunk-2d0c949d"
	],
	"./node/unirest_node.js": [
		"220c",
		"chunk-2d0b1d69"
	],
	"./php/curl.js": [
		"f6fa",
		"chunk-2d22d641"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2a49";
module.exports = webpackAsyncContext;